export default __webpack_public_path__ + "static/media/avatar_brown_bear7.a3d6ef60.mp3";